<template>
  <div class="featured-dorms__list dorm-card__list user-settings istatistik">
    <container class="gen-container">
      <div class="dorm-account-wrp">
        <div class="user-settings__top">
          <div class="user-settings__profil">
            <div class="left-one">
              <div class="left">
                <!-- <img src="/img/campuscity-logo.297a43a8.png" alt="" class="user-settings__profil-img"> -->
              </div>
              <div class="right" style="margin-left: -45px;"><p class="user-settings__profil-name">
                Welcome !
                <p class="user-settings__profil-mail">
                  {{first_name}}  {{last_name}}
                </p>
              <p class="user-settings__profil-name mail">
                {{mail}}
                <span class="sign-out">
                  <svg class="icon">
                    <use xlink:href="/icon/icons.svg#icon-mail"></use>
                  </svg>
                </span>
              </p>                
              </div>
            </div>
            <div class="right">

            </div>
          </div>
        </div>
      </div>

      <div class="dorm-account-wrp-two" style="width: 100%;display: flex;margin-top: 35px;">
        <div class="login-box login-box--personal">
          <div class="login-box__group">
            <div class="login-box__wrp-first">
              <h3 class="login-box__title setting">USER INFORMATION</h3>
              <div class="gen-text">
              <img :src="logo1" alt="" class="user-settings__profil-img2">
                <v-input placeholder="Movie Name" v-model="dorm_name" :value="dorm_name"/>
              </div>
                      <file-upload
          class="btn btn-primary"
          post-action="/upload/post"
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          :multiple="true"
          :size="1024 * 1024 * 10"
          v-model="logo"
          @input-filter="inputFilter"
          @input-file="inputFile"
          @change="handleImages"
          ref="upload">
          <i class="fa fa-plus"></i>
          Choose Avatar
          </file-upload>

<!--         <div class="col-xs-12 col-md-4 galeri-right">
          <div class="galeri-right-wrp">
            <div class="galeri-right__box">
                    <input
                      type="file"
                      class="form-control custom-input"
                      ref="logo"
                      multiple
                      @change="handleImages"
                    >
              <span class="galeri-right__icon">
              <svg-icon type="icon-gallery"/>
           </span>
            </div>
          </div>
        </div> -->        
            </div>

            <div class="login-box__wrp">
              <div class="gen-text">
                <v-input placeholder="Yetkili Adı" v-model="user.first_name" />
                <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
                <v-input placeholder="Yetkili Soyadı" v-model="user.last_name"  :value="user.last_name"/>
                <label for="password" v-if="emptyLastName" class="myValidationText">Can not be leave empty!</label>  
              </div>
              <v-input placeholder="Telephone" v-model="user.phone" :value="phone1"/>
              <label for="password" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
              <v-input placeholder="E-Posta Adresiniz" v-model="user.mail"  :value="email"/>
              <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label>
              <button class="button green fw shadow-none login-box__submit" @click="sendForm()">
               <span class="button__wrp">
                 <span class="button__txt">SAVE</span>
             </span>
              </button>
            </div>
          </div>
        </div>

        <div class="login-box session">
          <h3 class="login-box__title">SESSION INFORMATION</h3>
          <v-input placeholder="Current Password" v-model="password1"/>
          <label for="password" v-if="emptyPassword1"  class="myValidationText">Wrong password!</label>
          <label for="password" v-if="wrongPassword1"  class="myValidationText">Wrong password!</label>
          <v-input placeholder="Yeni Şifre" v-model="password2"/>
          <label for="password" v-if="emptyPassword2"  class="myValidationText">Can not be leave empty!</label>
          <v-input placeholder="Yeni Şifre Tekrar" v-model="password3"/>
          <label for="password" v-if="emptyPassword3"  class="myValidationText">Can not be leave empty!</label>
          <label for="phone" v-if="shortPasswordCheck" class="myValidationText">Password must be at least 6 characters!</label>
          <label for="password" v-if="notSamePassword" class="myValidationText">Both passwords must be same!</label> 
          <!--<v-select placeholder="Placeholder" :options="city"/>-->
          <button class="button green fw shadow-none login-box__submit" style="margin-top: 18px;" @click="sendSessionSettings()">
        <span class="button__wrp">
        <span class="button__txt">SAVE</span>
      </span>
          </button>
        </div>
      </div>
    </container>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >YOUR INFORMATION UPDATED!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Your account settings updated.</span></p>
      <p ><span class= "mycolorBlue">Please check your updated information.</span></p>
    </div>
     </div>
</div>
</Modal2>        
  </div>
</template>

<script>
import SelectBox from '@/components/SelectBox'
import Modal2 from '@/components/Modal2'
import { SET_USER_INFO, UNSET_TOKEN } from '@/store/mutations.type'
import { mapGetters } from 'vuex'
import FileUpload from 'vue-upload-component'
import axios from 'axios'
export default {
  name: 'DormUserAccount',
  components: { SelectBox, Modal2, FileUpload },
  data () {
    return {
      errors: [],
      logo: [],
      user: {},
      show: false,
      first_name1: null,
      showSuccessMessage: false,
      emptyName: false,
      emptyLastName: false,
      emptyPhone: false,
      emptyEmail: false,
      notSamePassword: false,      
      password1: '',
      password2: '',
      password3: '',
      wrongPassword1: false,
      emptyPassword1: false,
      emptyPassword2: false,
      emptyPassword3: false,
      shortPasswordCheck: false,
      shortPassword: false,      
      links: [
        {
          id: 0,
          title: 'İstatistik Özeti',
          to: '/yurtlar-istatistik'
        },
        {
          id: 1,
          title: 'Bilgilerim',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Rezervasyonlar',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Mesajlar',
          to: '/mesaj-liste'
        },
        {
          id: 4,
          title: 'Yurtlarım',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'İlanlarım',
          to: '/user-favorites'
        },
        {
          id: 6,
          title: 'Yorumlar',
          to: '/yurtlar-yorumlar'
        }
      ],
      linkMobile: [
        {
          name: 'Bilgilerim'
        },
        {
          name: 'İstatistik Öxeti'
        },
        {
          name: 'Mesajlar'
        },
        {
          name: 'Yurtlarım'
        },
        {
          name: 'Yorumlar'
        }
      ],
    }
  },
  methods: {
    handleImages(e) {
      let selectedFlies = e.target.files;
      if (!selectedFlies.length) {
        return false;
      }
      for (let i = 0; i < selectedFlies.length; i++) {
        this.logo.push(selectedFlies[i]);
      }
    },    
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },    
    closeModal() {
      this.showSuccessMessage = false
    },    
    sendSessionSettings () {
      this.wrongPassword1 = false;
      this.emptyPassword1 = false
      this.emptyPassword2 = false
      this.emptyPassword3 = false
      this.shortPassword = false
      this.shortPasswordCheck = false
      this.notSamePassword = false

      if (!this.password1) {
        this.emptyPassword1 = true
      }      
      if (!this.password2) {
        this.emptyPassword2 = true
      }
      if (!this.password3) {
        this.emptyPassword3 = true
      }
      if(!this.emptyPassword2 && this.password2.length < 6) {
        this.shortPassword = true
      }
      if(!this.emptyPassword3 && this.password3.length  < 6) {
        this.shortPasswordCheck = true
      }
      if (!this.emptyPassword3 && !this.shortPassword && !this.shortPasswordCheck && this.password2 != this.password3) {
        this.notSamePassword = true
      } 
      if(!this.emptyPassword1 && !this.emptyPassword2 && !this.emptyPassword3 && !this.notSamePassword && !this.shortPassword && !this.shortPasswordCheck) {      
      let self = this
      const pwd = window.localStorage.getItem('pwd')

      if(pwd == this.password1) {
        axios.put(`/dorm/password`, {
        old_password: this.password1,
        password_confirmation: this.password3,
        password: this.password2,
    })
    .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            }
        })
        .catch(e => {
          this.errors.push(e)
        })
        }
        else {
          this.wrongPassword1 = true;
        }
      }
    },
    sendForm() {
      this.emptyName = false
      this.emptyLastName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.shortPassword = false
      this.shortPasswordCheck = false
      
      if (!this.user.first_name) {
        this.emptyName = true
      }
      if (!this.user.last_name) {
        this.emptyLastName = true
      }    
      if (!this.user.phone) {
        this.emptyPhone = true
      }
      if (!this.user.mail) {
        this.emptyEmail = true
      }

      let dene = this.logo[0]
      if(!this.emptyName && !this.emptyLastName && !this.emptyPhone && !this.emptyEmail) {
      let self = this
      var data = {
        email: this.user.mail,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        center_name: this.dorm_name,
        logo: ''
                  }
            const formData = new FormData()
                Object.keys(data).map(e => {
                    formData.append(e, data[e]);
                })
                if(this.logo.length > 0) {
            formData.append("logo[]", this.logo[0].file);
                }


      let dene = this.user
      axios.put(`/dorm/info`, 
      {
        email: this.user.mail,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        center_name: this.dorm_name,
        logo: ''
      })
      .then(response => {
            if (response.status === 200 || response.status === 201) {
              this.$store.commit(SET_USER_INFO, self.user )
              window.localStorage.setItem('first_name1', this.user.first_name)
              window.localStorage.setItem('last_name1', this.user.last_name)
              window.localStorage.setItem('username1', this.user.first_name + ' ' + this.user.last_name)
              window.localStorage.setItem('mail1', this.user.mail)
              window.localStorage.setItem('phone1', this.user.phone)
              //window.localStorage.setItem('phone1', this.logo.filename)
              self.showSuccessMessage = true
            }
        })
        .catch(e => {
          this.errors.push(e)
        })
      }

    },    
    showDate () {
      this.show = true
    }
  },
  created() {
    this.dorm_name = window.localStorage.getItem('dorm_name')
    this.user.mail = this.mail1
    this.user.phone = this.phone
    this.logo1 = window.localStorage.getItem('logo')
    this.user.first_name = this.first_name
    this.user.last_name = this.last_name
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Bilgilerim',
      link: [
        { rel: 'canonical', href: window.location.origin + '/movies/info/' }
      ]
    }
  },  
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },  
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/dormAccount";

  .istatistik {
    .dorm-account-wrp {
      width: 100%;
    }

    .gen-container {
      flex-direction: column;
    }

    .select__placeholder {
      font-size: 16px;
      font-weight: 100;
    }

    .select__caret {
      background-color: #f5f8fc;
      width: 28px;
      height: 28px;
      font-size: 10px;
    }

    .user-settings__profil {
      width: 100%;

    }

    .select-box {
      border-bottom: 0 !important;
    }

    .user-settings__top {
      border-bottom: 1px solid #cbd0dd6b;
    }

    .user-settings__profil {
      display: flex;
      justify-content: space-between;

      .left-one {
        display: flex;
        align-items: center;
      }
    }

    .user-settings__profil-img {
      width: 100%;
      border: 3px solid white;
      border-radius: 10px;
      background-color: white;
      padding: 13px;
      box-shadow: 0px 8px 60px 0px rgba(62, 62, 141, 0.05);
    }

    .user-settings__profil-mail {
      margin-right: 102px;
      color: #656e8d;
      font-size: 19px;
      font-weight: bold;
    }

    .user-settings__profil-name.mail {
      font-size: 16px;
      padding-right: 35px;

      .sign-out {
        margin-left: 16px;
        font-size: 24px;
        font-weight: bold;
      }

    }

    .container2 {
      display: block;
      position: relative;
      padding-bottom: 8px;
      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      width: 48%;
      margin-right: 16px;
    }

    .container2 input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    .checkmark {
      position: absolute;
      left: 6px;
      height: 14px;
      width: 14px;
      border-radius: 3px;
      background-color: #eff3fb;
      border: 1px solid #d8d8d8;
    }

    /* On mouse-over, add a grey background color */
    .container2:hover input ~ .checkmark {
      background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container2 input:checked ~ .checkmark {
      background-color: #15d2a3;
      border-color: #15d2a3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    .container2 input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    .container2 .checkmark:after {
      left: 4px;
      top: 1px;
      width: 5px;
      height: 9px;
      border: 1px solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    .dorm-statistic {
      margin-top: 20px;

      .statistic {
        &-top {
          display: flex;
          justify-content: space-between;
        }

        &__item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: white;
          padding: 31px 0px;
          border-radius: 14px;
          box-shadow: 0px 8px 60px 0px rgba(62, 62, 141, 0.05);
          position: relative;
          width: 25%;
          margin-right: 17px;

          &:last-child {
            margin-right: 0;
          }

          &-title {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            text-align: center;
            padding: 22px 0 11px 0px;
            font-size: 16px;
            font-weight: bold;
            border-bottom: 1px solid #f9f9f9;
            color: #4b5da1;
          }

          &-middle {
            text-align: center;
            margin-top: 21px;
            margin-bottom: 11px;
          }

          &-text {
            position: relative;
            top: -21px;
          }

          &-number {
            font-size: 60px;
          }

          &-days {
            position: absolute;
            bottom: 11px;
            left: 0;
            width: 100%;
            text-align: center;
            border-top: 1px solid #f9f9f9;
            padding: 12px 0 0px 0;
            color: #a1a7be;
            font-size: 16px;
            margin-left: 3px;

            .oclcok {
              position: relative;
              top: -2px;
              font-size: 15px;
              color: #4face2;
              position: relative;
              left: -5px;
            }
          }
        }
      }
    }

    .report {
      background-color: white;
      border-radius: 9px;
      margin-top: 29px;
      padding: 20px 28px;
      box-shadow: 0px 8px 60px 0px rgba(62, 62, 141, 0.05);

      &__top {
        display: flex;
        align-items: center;
      }

      &-right {
        width: 30%;
        margin-left: auto;
        display: flex;

        &__item {
          width: 50%;
        }
      }

      &__title {
        color: #4b5da1;
        font-weight: bold;
        font-size: 16px;
      }

      &__text {
        color: #a1a7be;
        font-size: 16px;
      }

      &__bottom {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid whitesmoke;
        padding: 20px 0;
        margin: 15px 0;

        &-item {
          display: flex;
          width: 24%;
          background-color: #f5f8fc;
          align-items: center;
          justify-content: space-evenly;
          padding: 15px 0;
          border-radius: 8px;
        }
      }

      &-icon {
        color: white;
        background-color: #62b2eb;
        padding: 11px 15px;
        border-radius: 100%;
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;

        .oclcok {
          position: relative;
          left: 0px;
        }
      }

      &-detail {
        &__number {
          color: #62b2eb;
          font-weight: bold;
        }

        &__text {
          color: #a1a7be;
          font-size: 15px;
          position: relative;
          margin-top: -9px;
        }
      }

    }
  }

  .user-settings {
    margin-top: 0;
  }

  .account-dorms {
    .user-settings__top {
      border-bottom: 1px solid #cbd0dd6b;
    }

    .user-settings__profil-img {
      width: 100% !important;
      border: 3px solid white;
      border-radius: 10px;
      background-color: white;
      padding: 13px;
      box-shadow: 0px 8px 60px 0px rgba(62, 62, 141, 0.05);
    }

    .user-settings__profil-mail {
      margin-right: 102px;
      color: #656e8d;
      font-size: 19px;
      font-weight: bold;
    }

    .user-settings__profil-name.mail {
      font-size: 16px;
      padding-right: 35px;

      .sign-out {
        margin-left: 16px;
        font-size: 24px;
        font-weight: bold;
      }

    }
  }

  .select__title {
    font-size: 13px !important;
    color: #31363a;
    opacity: 0.7;
  }

</style>
